import { ACTIVE_ITEMS } from '@constants/activeItems';
import { Autocomplete, Box, TextField } from '@mui/material';
import { RootContext } from 'components/RootContainer';
import { FC, useContext, useState } from 'react';
import { useQuery } from 'react-query';
import { useDebounce } from 'use-debounce';
import { MenuItem } from '../../../../components/styled/SelectMenuItem';
import { NationalityModel } from '../../../../services/Settings/NationalityService';

export const NationalityField: FC<{
  value: NationalityModel | null;
  onChange: (value: NationalityModel | null) => void;
  error?: React.ReactNode;
}> = ({ value, onChange, error }) => {
  const {
    ChainApi: {
      settings: {
        nationality: { getAll },
      },
    },
  } = useContext(RootContext);

  const [search, setSearch] = useState<string>('');

  const [searchDebounced] = useDebounce(search, 500);

  const { isLoading, data } = useQuery({
    queryKey: ['get-nationalities', searchDebounced],
    queryFn: () => {
      return getAll({
        search: [
          {
            column: 'name',
            operator: 'like',
            value: searchDebounced,
          },
          ACTIVE_ITEMS,
        ],
        limit: 100,
        offset: 0,
      });
    },
    enabled: true,
  });

  return (
    <Box>
      <Autocomplete
        options={data ?? []}
        loading={isLoading}
        getOptionLabel={option => option.name ?? ''}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        renderOption={(props, option, state) => (
          <MenuItem {...props} value={option.id} key={`${option?.id}-${option?.name}`}>
            {option.name}
          </MenuItem>
        )}
        value={value}
        onChange={(e, newValue) => {
          onChange(newValue);
        }}
        // inputValue={value}
        onInputChange={(e, value, reason) => {
          if (reason === 'clear') {
            setSearch('');
            onChange(null);
          } else {
            setSearch(value);
          }
        }}
        renderInput={props => (
          <TextField
            {...props}
            variant="standard"
            fullWidth
            label={'Nationality'}
            placeholder={'Nationality'}
            inputProps={{
              ...props.inputProps,
              autoComplete: 'new-password',
            }}
          />
        )}
      />
    </Box>
  );

  // return (
  //   <Box
  //     sx={{
  //       boxShadow: 'inset 0 -1px 0 0 #d2d7de',
  //       pb: 2,
  //     }}
  //   >
  //     <FormControl variant="standard" fullWidth>
  //       <InputLabel shrink>Nationalities</InputLabel>
  //       <Box
  //         sx={{
  //           mt: 3,
  //           maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
  //           overflow: 'auto',
  //         }}
  //       >
  //         <FormGroup
  //           sx={{
  //             display: 'flex',
  //             flexDirection: 'column',
  //           }}
  //         >
  //           <FormControlLabel
  //             control={
  //               <Checkbox
  //                 checked={!value}
  //                 onChange={() => handleChange('all' as unknown as number)}
  //                 sx={{ mr: 1 }}
  //               />
  //             }
  //             label={t('list.filter.all')}
  //             sx={{ py: 0.5, pl: 1.5 }}
  //           />
  //           {(data || [])?.map(nationality => (
  //             <FormControlLabel
  //               key={nationality.id}
  //               control={
  //                 <Checkbox
  //                   checked={value?.includes(+nationality.id!) ?? false}
  //                   onChange={() => handleChange(+nationality.id!)}
  //                   sx={{ mr: 1 }}
  //                 />
  //               }
  //               label={nationality.name}
  //               sx={{ py: 0.5, pl: 1.5 }}
  //             />
  //           ))}
  //         </FormGroup>
  //       </Box>
  //     </FormControl>
  //   </Box>
  // );
};
